/* prettier-ignore */

import { Injectable } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { RestService } from 'src/app/services/rest.service';
import { NavController } from '@ionic/angular'

@Injectable({
  providedIn: 'root'
})

export class NavigationService {
  private history: string[] = []

  constructor(private router: Router, public rest: RestService, public navCtrl: NavController) { }

  public startSaveHistory():void{
    const customRoutePattern = /^\/custom-route\/\d+$/;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (!customRoutePattern.test(event.urlAfterRedirects) && this.history?.[this.history?.length - 1] !== event.urlAfterRedirects )
          this.history.push(event.urlAfterRedirects)
      }
    })
  }

  public resetNavigation(){
    this.history = [];
  }

  public goBack(): void {
    this.history.pop();
    if (this.history.length > 0) {
      const lastUrl = this.history.pop();
      if (lastUrl.includes('survey-id') || lastUrl.includes('not-found') || lastUrl.includes('iframe') || lastUrl.includes('send-update-route')){
        this.history = [];
        this.router.navigateByUrl('/home');
        return;
      }
      this.router.navigateByUrl(lastUrl)
    } else {
      this.router.navigateByUrl('/home')
    }
  }

}